/* tslint:disable */
var TSystemSPSLipMode = (function () {
    "use strict";
    var api = <any>{};

    // Overrides SystemSPSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };

    // Template logic splitter
    api.buildOptions = function (selections) {
        this.calcVariants();
        return TMultiOptions.buildSystem(this, selections) || "";
    };

    // Adapter for Array.push template implementation
    api.buildSelectionInnerView = function (__html, selection, selectionUpdated) {
        __html.push(TBuildLine.buildInnerView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true }));
    };

    api.buildHeader = function () {
        return "";
    };

    return api;
}());

window.TSystemSPSLipMode = TSystemSPSLipMode;
